import { useTranslations } from 'next-intl'

import { useGuestReceiptInformation } from '@/features/update-receipt-information'
import { cn } from '@/shared/lib'
import { Dialog } from '@/shared/ui'

import { UpdateReceiptInformationForm } from './form'

type Props = {
  isOpen: boolean
  onOpenChange: (isOpen: boolean) => void
  contractId: number
  onSuccess?: () => void
  onClose?: () => void
}

export const UpdateReceiptInformationDialog = ({
  isOpen,
  onOpenChange,
  contractId,
  onSuccess,
  onClose,
}: Props) => {
  const t = useTranslations('receipt_information')

  const { receiptInformation } = useGuestReceiptInformation({
    contractId,
  })

  const isFormEditable = receiptInformation?.isEditAvailable ?? true

  const handleOpenChange = (open: boolean) => {
    if (isFormEditable && !open) {
      return
    }

    onOpenChange(open)
  }

  const handleClose = () => {
    if (isFormEditable) {
      onClose?.()
    } else {
      onOpenChange(false)
    }
  }

  return (
    <Dialog.Root open={isOpen} onOpenChange={handleOpenChange}>
      <Dialog.Content
        className={cn('gap-0 p-0', isFormEditable && 'h-[760px]')}
        onClose={handleClose}
      >
        <Dialog.Header className="p-6">
          <Dialog.Title className="text-start">{t('title')}</Dialog.Title>
        </Dialog.Header>
        <UpdateReceiptInformationForm
          contractId={contractId}
          onSuccess={onSuccess}
          onClose={handleClose}
        />
      </Dialog.Content>
    </Dialog.Root>
  )
}
